import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import axiosNoInterceptor from '../../services/axiosNoInterceptor';
import { getCategories } from '../useCategories';
import { CACHE_VERSION_URL, MENU_CACHE_VERSION_KEY } from '../../constants';

interface IAuthInfo {
    userId: number;
    type: string | null;
}

export default function useMenuPrefetch(
    location_id: string | undefined,
    _authInfo: IAuthInfo
) {
    const queryClient = useQueryClient();
    useEffect(() => {

        const checkVersion = async () => {
            try {
                const response = await axiosNoInterceptor.get(CACHE_VERSION_URL);
                const cache_version = Number(response.data?.cache_version) || 0.1;
                const storedVersion = Number(localStorage.getItem(MENU_CACHE_VERSION_KEY));

                if (cache_version !== storedVersion) {
                    queryClient.removeQueries('categories');
                    queryClient.removeQueries('try2combo');
                    queryClient.removeQueries('kidscombo');
                    localStorage.setItem(MENU_CACHE_VERSION_KEY, String(cache_version));
                }
            } catch (_) {
                // Fail silently — stale cache is better than a broken menu
            }
        };
        checkVersion();
    }, [location_id]);
}

export async function prefetchMenuOnAppLoad(
    queryClient: any,
    location_id,
    user
) {
    try {
        const response = await axiosNoInterceptor.get(CACHE_VERSION_URL);
        const cache_version = Number(response.data?.cache_version) || 0.1;
        const storedVersion = Number(localStorage.getItem(MENU_CACHE_VERSION_KEY));

        if (cache_version !== storedVersion) {
            queryClient.removeQueries('categories');
            queryClient.removeQueries('try2combo');
            queryClient.removeQueries('kidscombo');
            localStorage.setItem(MENU_CACHE_VERSION_KEY, String(cache_version));
            queryClient.prefetchQuery(
                ["categories", location_id, cache_version],
                () => getCategories(location_id, user),
                {
                    staleTime: Infinity,
                    cacheTime: 1000 * 60 * 60,
                }
            )
        }
    } catch (_) {
        // Fail silently; the menu will load normally on navigation
    }
}